import { reduxForm, reset } from 'redux-form'
import moment from 'moment'

import CommentForm from '../../components/comments/comment-form'

import { createCommentForIssue } from '../../actions/comments'

const fields = [
  'body',
  'timezone'
]

function mapDispatchToProps (dispatch, ownProps) {
  return {
    onSubmit (data) {
      dispatch(createCommentForIssue(ownProps.issueId, data))
        .then(() => dispatch(reset('createIssueComment')))
    }
  }
}

export default reduxForm(
  {
    fields,
    initialValues: {
      timezone: moment.tz.guess()
    },
    form: 'createIssueComment'
  },
  undefined,
  mapDispatchToProps
)(CommentForm)



// WEBPACK FOOTER //
// ./src/containers/comments/create-issue-comment-container.js